import instanceService from './instance'

import {AUTOLOMBARD_REQUESTS_URL, KB_EXCHANGE_SERVER_URL} from '../helpers/constants'
import {AutolombardDocumentTypes} from "../components/AutoLombard/constants/constants";

let instance = instanceService.instance(AUTOLOMBARD_REQUESTS_URL)
let instanceKB = instanceService.instance(KB_EXCHANGE_SERVER_URL)

export const autoLombardService = {
  getRequests(data) {
    return instance({
      method: 'POST',
      url: `/requests`,
      data,
    });
  },
  getPaymentSchedule(data) {
    return instance({
      method: 'POST',
      url: `/deals/calculate`,
      data,
    });
  },
  withdrawCarDeposit(requestId) {
    return instance({
      method: 'POST',
      url: `requests/${requestId}/collateral-remove`,
    });
  },
  creditRegister(data) {
    return instanceKB({
      method: 'POST',
      url: `/kb/event`,
      data,
    });
  },
  fetchChangeHistory(data) {
    return instance({
      method: 'GET',
      url: `/requests/${data.id}/changelog`,
      data,
    });
  },
  setComments(data) {
    return instance({
      method: 'PATCH',
      url: `/requests/${data.id}/revision`,
      data: {...data.data},
    });
  },

  getRequestById(requestId) {
    return instance({
      method: 'GET',
      url: `/requests/${requestId}`,
    });
  },

  inprogressRequest({requestId}) {
    return instance({
      method: 'POST',
      url: `/requests/${requestId}/inprogress`,
    });
  },

  approveRequest({requestId, data}) {
    return instance({
      method: 'POST',
      url: `/requests/${requestId}/approve`,
      data,
    });
  },

  rejectRequest({requestId, data}) {
    return instance({
      method: 'POST',
      url: `/requests/${requestId}/reject`,
      data,
    });
  },

  cancelRequest({requestId}) {
    return instance({
      method: 'POST',
      url: `/requests/${requestId}/cancel`,
    });
  },

  getRequestClients(data) {
    return instance({
      method: 'POST',
      url: `/clients`,
      data,
    });
  },

  getDocumentById({documentId, documentType}) {
    const isIncomeVerification = documentType === AutolombardDocumentTypes.INCOME_VERIFICATION
    return instance({
      method: 'GET',
      url: `/documents/${isIncomeVerification ? `income/${documentId}` : documentId}`,
    });
  },

  updateRequest({ requestId, data }) {
    return instance({
      method: "PATCH",
      url: `/requests/${requestId}`,
      data
    });
  },

  createOneAppClient({ albClientId }) {
    return instance({
      method: "POST",
      url: `/clients/${albClientId}/create`
    });
  },

  debtLoadRequest({ oneClientId, data }) {
    return instance({
      method: "POST",
      url: `/pdn/${oneClientId}/calculate`,
      data
    });
  }, 
};
